import { render, staticRenderFns } from "./ItemChipsWithMore.vue?vue&type=template&id=04e3f2fb"
import script from "./ItemChipsWithMore.vue?vue&type=script&lang=ts"
export * from "./ItemChipsWithMore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e3f2fb')) {
      api.createRecord('04e3f2fb', component.options)
    } else {
      api.reload('04e3f2fb', component.options)
    }
    module.hot.accept("./ItemChipsWithMore.vue?vue&type=template&id=04e3f2fb", function () {
      api.rerender('04e3f2fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ItemChipsWithMore.vue"
export default component.exports